import axios from 'axios';
import { LocationTypes } from '../locationTypes';

const mapsApiBaseUrl = `https://v11-tfw-api.codeparva.com`;
// const mapsApiBaseUrl = `http://localhost:3123`;
const mapsBaseUrl = `https://www.google.com/maps`;

const placeDetailsRequest = axios.create({
  baseURL: `${mapsApiBaseUrl}/g-maps`,
});

export const getPlaceDetailsById = async (placeId: string) => {
  try {
    const requestBody = {
      placeId: placeId,
      fields:
        'name,opening_hours,geometry,rating,formatted_address,user_ratings_total',
    };
    const apiResult = await placeDetailsRequest.post('', requestBody, {
      headers: {
        'Access-Control-Allow-Origin': '*',
      },
    });
    const { data, status } = apiResult;
    if (status && (status === 200 || status === 201)) {
      return {
        data,
        error: null,
      };
    }
  } catch (error) {
    if (error instanceof Error) {
      return {
        data: null,
        error: error.message,
      };
    }
  }
};

export const generateMapLink = (config: LocationTypes.TMapUrlConfig) => {
  const { origin, destination } = config;
  const mapUrl = `${mapsBaseUrl}/dir/?api=1&origin=${origin.lat},${origin.lng}&destination=${destination.coords.lat}, ${destination.coords.lng}&destination_place_id=${destination.placeId}`;
  return encodeURI(mapUrl);
};

export const generateDestinationMapLink = (
  destination: LocationTypes.TDestinationConfig
) => {
  const mapUrl = `${mapsBaseUrl}/dir/?api=1&destination=${destination.coords.lat},${destination.coords.lng}&destination_place_id=${destination.placeId}`;
  return encodeURI(mapUrl);
};

export const handleGetDirections = (
  destinationPlaceId: string,
  gMapDetails: LocationTypes.TGMapLocation,
  setMessage?: React.Dispatch<React.SetStateAction<string>>,
  onMapUrlGenerated?: (mapUrl: string) => void
) => {
  const onCurUserLocationSuccess = (
    result: LocationTypes.IGeolocationPosition
  ) => {
    if (result) {
      const {
        coords: { latitude, longitude },
      } = result;
      if (gMapDetails) {
        const mapConfig: LocationTypes.TMapUrlConfig = {
          origin: {
            lat: latitude,
            lng: longitude,
          },
          destination: {
            coords: {
              lat: gMapDetails.geometry.location.lat,
              lng: gMapDetails.geometry.location.lng,
            },
            placeId: destinationPlaceId,
          },
        };
        const mapUrl = generateMapLink(mapConfig);
        if (mapUrl && window) {
          setMessage && setMessage('');
          if (onMapUrlGenerated) {
            onMapUrlGenerated(mapUrl);
          } else {
            window.open(mapUrl, '_blank');
          }
        } else {
          setMessage && setMessage('Sorry!! We could not open the directions');
        }
      } else {
        setMessage && setMessage('Cannot find directions to destination.');
      }
    } else {
      if (setMessage) {
        setMessage('Error while resolving current address');
      }
    }
  };

  const onCurUserLocationError = (
    error: LocationTypes.IGeolocationPositionError
  ) => {
    console.log(
      'There was an error while getting current user location:',
      error
    );
    setMessage && setMessage('There was an error while fetching location!!');
  };

  if (window && window.navigator.geolocation) {
    const { geolocation } = window.navigator;
    if (geolocation) {
      geolocation.getCurrentPosition(
        onCurUserLocationSuccess,
        onCurUserLocationError
      );
      setMessage && setMessage('');
    } else {
      setMessage && setMessage('Sorry!! Your Browser Does Not Support.');
    }
  }
};
